import * as yup from "yup";
import { boolean } from "yup";

import type {
  RegistrationData,
  RegistrationFormValues,
} from "./RegistrationForm";

export const registrationSchema = (
  data: RegistrationData,
): yup.ObjectSchema<RegistrationFormValues> => {
  return yup.object().shape({
    nick: yup
      .string()
      .required(data?.validation_required ?? "Required field")
      .min(3, data?.validation_nickname_min_length ?? "Nickname too short")
      .max(16, data?.validation_nickname_max_length ?? "Nickname too long")
      .test(
        "nick-does-not-contain-password",
        data?.validation_nickname_contain_password ??
          "Nickname should not contain password!",
        function (value) {
          const { password } = this.parent as RegistrationFormValues;

          return !value.includes(password);
        },
      )
      .test(
        "nick-not-only-numbers",
        data?.validation_nickname_contains_only_numbers ??
          "Nickname should not contain only numbers",
        (value) => {
          if (!value) return true;
          return /\D/.test(value);
        },
      ),
    email: yup
      .string()
      .required(data?.validation_required ?? "Required field")
      .email(data?.validation_invalid_email ?? "Invalid email format")
      .min(
        6,
        data?.validation_email_min_length ??
          "Must be at least 6 characters long",
      )
      .max(
        30,
        data?.validation_email_max_length ?? "Must be at most 30 characters",
      )
      .test(
        "has-tld",
        data?.validation_invalid_email ??
          "Email must have a top-level domain (.com, .ru, etc)",
        (value) => {
          if (!value) return true;
          return /\.[a-zA-Z]{2,}$/.test(value);
        },
      ),
    password: yup
      .string()
      .required(data?.validation_required ?? "Required field")
      .matches(
        /^[A-Za-z0-9!@#$%^&*()_+\-={};':"\\|,.<>/?]+$/,
        data?.validation_invalid_password ?? "Invalid characters used",
      )
      .min(5, data?.validation_password_min_width ?? "Password too short")
      .max(20, data?.validation_password_max_width ?? "Password too long"),

    bonusCode: yup.string().optional(),
    isRememberPassword: boolean().optional(),
  });
};
